import Link from 'next/link';

import styled from '@emotion/styled';

import { isEmpty, head } from 'lodash';

import {
  ProductBannerData,
} from '../../types';

const BannerView = styled.div`
  padding-bottom: 28px;
  text-align: center;
`;

const BannerImg = styled.img`
  width: 100%;
  vertical-align: top;
  cursor: pointer;
`;

interface Props {
  banner: ProductBannerData[];
  onClickBanner(url: string): void;
}

export default function Banner({
  banner, onClickBanner,
}: Props) {
  const headBanner = head(banner);
  if (!headBanner) {
    return null;
  }
  const { pcLink, pcImage } = headBanner;

  return (
    <BannerView>
      {isEmpty(pcLink)
        ? <BannerImg src={pcImage} />
        : <Link href={pcLink || ''}>
          <BannerImg src={pcImage} alt="배너 이미지" onClick={() => onClickBanner(pcLink)} />
        </Link>
      }
    </BannerView>
  );
}
